var map = {
	"./CollaborativeAutomation.jpg": "6b21",
	"./IntelligenceIndustrialSolutions.jpg": "6c01",
	"./NationalTechnicalInventionAward.jpg": "8e39",
	"./bk/homeBuilding.jpg": "76fa",
	"./homeBuilding.jpg": "dfad",
	"./home_prj_bljqr.jpg": "c9f5",
	"./home_prj_hlhkzxt.jpg": "7a9e",
	"./home_prj_qygl.jpg": "4cfb",
	"./ifactory.jpg": "59a1",
	"./shengjimix.jpg": "723b",
	"./slide-10.jpg": "b54a",
	"./slide-11.jpg": "8436",
	"./slide-12.jpg": "2df4",
	"./slide-13.jpg": "09c7",
	"./slide-14.png": "ebfa",
	"./slide-15.png": "805f",
	"./slide-15_medium.png": "8af9",
	"./slide-15_small.png": "874d",
	"./slide-2.png": "f1e0",
	"./slide-3.jpg": "7e2f",
	"./slide-4.png": "220c",
	"./slide-7.jpg": "e1f6",
	"./slide-8.png": "a8f1",
	"./slide-9.jpg": "c20a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d44";